<sbnb-signup-header></sbnb-signup-header>
<section class="sbnb-onboarding">
  <div class="content" fxLayout="column">
    <section fxLayout fxLayoutGap="10px">
      <sbnb-icon-airbnb fxFlex="0 0 26px" fxHide.lt-md [size]="26"></sbnb-icon-airbnb>
      <h2 class="nomargin" style="line-height: 1.5">
        <span>Connecting Hospitable.com with Airbnb</span>
      </h2>
    </section>

    <section>
      <p>We’re an official Airbnb software partner, so connecting takes minutes.</p>
      <p>
        Connecting your Airbnb account will allow you to save time replying to guests and automate the review process.
      </p>
      <p>
        Before you click Continue, make sure you are logged in to Airbnb with the account you want to connect to
        Hospitable.com.
      </p>
    </section>

    <section>
      <form [formGroup]="form">
        <div style="margin-top: 12px; margin-bottom: 12px; margin-left: -6px">
          <mat-checkbox formControlName="agreed_to_tos">
            <span class="text__small">
              I agree to to Hospitable's
              <a href="{{ config.TOS_URL }}" target="_blank" class="strong" target="_blank">Terms of Service</a>
              and
              <a href="{{ config.PRIVACY_POLICY_URL }}" target="_blank" class="strong" target="_blank">
                Privacy Policy
              </a>
            </span>
          </mat-checkbox>
        </div>
      </form>

      <div
        fxLayout
        fxLayoutGap="18px"
        fxLayoutAlign="end center"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center stretch">
        <button
          id="connect-permissions-cancel"
          mat-flat-button
          fxFlexOrder.lt-md="99"
          class="button__secondary"
          [routerLink]="['/user/register/welcome']">
          Cancel
        </button>
        <!-- <sbnb-button [disabled]="!form.valid"
          [loading]="" (click)="signUpWithAirbnb()"
          mat-flat-button fxFlexOrder.lt-md="99" class="button__primary">
          Connect
        </sbnb-button> -->

        <button
          mat-flat-button
          [disabled]="!form.valid || (signUpWithAirbnbLoadingState$ | async) === LoadingState.Pending"
          (click)="signUpWithAirbnb()">
          Continue
          <mat-spinner
            class="button__spinner"
            *ngIf="(signUpWithAirbnbLoadingState$ | async) === LoadingState.Pending"
            diameter="30"></mat-spinner>
        </button>
      </div>
    </section>
  </div>
</section>
